import { Type } from "@angular/core";

import { DevicePostfixPipe } from "./pipes/device-postfix.pipe";
import { TruncatePipe } from "./pipes/truncate.pipe";

export const UTIL_PIPES: Type<unknown>[] = [TruncatePipe, DevicePostfixPipe];
